module.exports = __webpack_public_path__ + "zilla-slab-latin-500italic.c8469aa27bfb0ba6fe59fd7f4137904e.woff2";